import en from './en';
import { panelDepositWithdrawInboxByLang } from './partials/panelDepositWithdrawInbox';
import { panelDepositBonusByLang } from './partials/panelDepositBonusI18n';
import { panelVoucherStatusByLang } from './partials/panelVoucherStatusI18n';
import { panelInvestmentsByLang } from './partials/panelInvestmentsI18n';
import { panelStopLossSlotsAssignByLang } from './partials/panelStopLossSlotsAssignI18n';
import { panelStopLossFlowByLang } from './partials/panelStopLossFlowI18n';
import { panelUserSignupSocialForgotByLang } from './partials/panelUserSignupSocialForgotI18n';
import { panelAgentDashboardByLang } from './partials/panelAgentDashboardI18n';
import { panelAgentReferralsByLang } from './partials/panelAgentReferralsI18n';
import { panelAgentCommissionsByLang } from './partials/panelAgentCommissionsI18n';
import { panelAgentWithdrawByLang } from './partials/panelAgentWithdrawI18n';
import { panelAgentWithdrawUnlockStringsByLang } from './partials/panelAgentWithdrawUnlockStringsI18n';
import { panelAgentTransactionsByLang } from './partials/panelAgentTransactionsI18n';
import { panelAgentLogsByLang } from './partials/panelAgentLogsI18n';
import { panelAgentSettingsByLang } from './partials/panelAgentSettingsI18n';
import { panelAgentNotificationsByLang } from './partials/panelAgentNotificationsI18n';
import { panelAgentTeamByLang } from './partials/panelAgentTeamI18n';
import { panelAgentSignupByLang } from './partials/panelAgentSignupI18n';
import { panelAgentLayoutByLang } from './partials/panelAgentLayoutI18n';
import { panelAgentAuthByLang } from './partials/panelAgentAuthI18n';
import { panelSettingsTransactionsByLang, panelUserExtraByLang } from './partials/panelSettingsTransactions';
import { panelUserPlatformTodayByLang } from './partials/panelUserPlatformTodayI18n';
import { panelStopLossHowLayoutByLang } from './partials/panelStopLossHowLayoutI18n';
import { panelSupportTicketsByLang } from './partials/panelSupportTicketsI18n';
import { panelReferralCurrentRankMinDepositByLang } from './partials/panelReferralRankingI18n';

function m(p) {  return { ...en, ...p };
}

export default m({
  'common.theme': 'Thema',
  'common.themeLight': 'Hell',
  'common.themeDark': 'Dunkel',
  'common.themeActive': 'Derzeit aktiv',
  'common.themeSwitchToDark': 'Zu Dunkel wechseln',
  'common.themeSwitchToLight': 'Zu Hell wechseln',
  'common.settings': 'Einstellungen',
  'common.loading': 'Laden…',
  'settings.language': 'Sprache',
  'settings.savePreferences': 'Einstellungen speichern',
  'settings.savingPreferences': 'Speichern…',
  'auth.gate.userTitle': 'Sitzung wird geprüft',
  'auth.gate.userDescription': 'Anmeldung wird bestätigt. Einen Moment.',
  'auth.gate.agentTitle': 'Sitzung wird geprüft',
  'auth.gate.agentDescription': 'Agent-Anmeldung wird bestätigt. Einen Moment.',
  'user.layout.sidebarTitle': 'MineMe Nutzer',
  'user.layout.logout': 'Abmelden',
  'user.layout.nav.dashboard': 'Dashboard',
  'user.layout.nav.deposit': 'Einzahlung',
  'user.layout.nav.withdraw': 'Auszahlung',
  'user.layout.nav.investments': 'Investitionen',
  'user.layout.nav.referral': 'Empfehlung',
  'user.layout.nav.notifications': 'Benachrichtigungen',
  'user.layout.nav.stopLoss': 'Stop-Loss',
  'user.layout.nav.transactions': 'Transaktionen',
  'user.layout.nav.settings': 'Einstellungen',
  'user.layout.balance.available': 'Verfügbarer Saldo',
  'user.layout.balance.frozen': 'Eingefrorener Saldo',
  'user.layout.balance.interest': 'Zinssaldo',
  'user.layout.balance.bonus': 'Bonus-Saldo',
  'user.dashboard.balance.available': 'Verfügbarer Saldo',
  'user.dashboard.balance.frozen': 'Eingefrorener Saldo',
  'user.dashboard.balance.interest': 'Verdiente Zinsen',
  'user.dashboard.balance.bonus': 'Bonus-Saldo',

  'common.time.days': 'Tage',
  'common.time.hours': 'Stunden',
  'common.time.minutes': 'Minuten',
  'common.time.seconds': 'Sekunden',

  'user.dashboard.title': 'Dashboard',
  'user.dashboard.loadingInvestments': 'Anlagestatus wird geladen…',
  'user.dashboard.stats.totalInvested': 'Gesamt investiert',
  'user.dashboard.stats.netPnl': 'Netto Gewinn / Verlust',
  'user.dashboard.stats.activePlans': 'Aktive Pläne',
  'user.dashboard.noInvestment.title': 'Keine aktive Investition',
  'user.dashboard.noInvestment.subtitle':
    'Investieren Sie noch heute und lassen Sie Ihr Vermögen mit attraktiven Renditen wachsen',
  'user.dashboard.noInvestment.cta': 'Anlagepläne entdecken',
  'user.dashboard.recentTx.title': 'Letzte Transaktionen',
  'user.dashboard.recentTx.viewAll': 'Alle anzeigen',
  'user.dashboard.recentTx.col.date': 'Datum',
  'user.dashboard.recentTx.col.type': 'Typ',
  'user.dashboard.recentTx.col.description': 'Beschreibung',
  'user.dashboard.recentTx.col.amount': 'Betrag',
  'user.dashboard.recentTx.col.status': 'Status',
  'user.dashboard.recentTx.loading': 'Letzte Transaktionen werden geladen…',
  'user.dashboard.recentTx.empty': 'Keine letzten Transaktionen.',
  'user.dashboard.tx.Deposit': 'Einzahlung',
  'user.dashboard.tx.Investment': 'Investition',
  'user.dashboard.tx.Referral': 'Empfehlung',
  'user.dashboard.tx.Bonus': 'Bonus',
  'user.dashboard.tx.Withdrawal': 'Auszahlung',
  'user.dashboard.tx.E-Voucher': 'E-Gutschein',
  'user.dashboard.tx.Stop-Loss': 'Stop-Loss',
  'user.dashboard.st.Completed': 'Abgeschlossen',
  'user.dashboard.st.Active': 'Aktiv',
  'user.dashboard.st.Pending': 'Ausstehend',
  'user.dashboard.st.Failed': 'Fehlgeschlagen',
  'user.dashboard.invest.planFallback': 'Plan',
  'user.dashboard.invest.activeBadge': 'Aktiv',
  'user.dashboard.invest.detail.amountInvested': 'Investierter Betrag',
  'user.dashboard.invest.detail.currentValue': 'Aktueller Wert',
  'user.dashboard.invest.detail.pl': 'G/V',
  'user.dashboard.invest.detail.interestRate': 'Zinssatz',
  'user.dashboard.invest.detail.perMonth': '{{pct}} % pro Monat',
  'user.dashboard.invest.detail.duration': 'Laufzeit',
  'user.dashboard.invest.detail.months': '{{n}} Monate',
  'user.dashboard.invest.detail.startDate': 'Startdatum',
  'user.dashboard.invest.detail.nextWithdrawal': 'Nächste Auszahlung',
  'user.dashboard.invest.countdownTitle': 'Nächste Auszahlung in',
  'user.dashboard.invest.progress': 'Fortschritt',
  'user.dashboard.invest.progressPct': '{{pct}} % abgeschlossen',
  'user.dashboard.invest.earlyWithdraw': 'Vorzeitige Auszahlung',
  'user.dashboard.invest.planChip': '{{name}} Nr. {{num}}',
  'user.dashboard.invest.modal.title': 'Hinweis: vorzeitige Auszahlung',
  'user.dashboard.invest.modal.investmentAmount': 'Investitionsbetrag:',
  'user.dashboard.invest.modal.platformFee': 'Plattformgebühr ({{pct}} %):',
  'user.dashboard.invest.modal.interestForfeited': 'Verfallene Zinsen:',
  'user.dashboard.invest.modal.youWillReceive': 'Sie erhalten:',
  'user.dashboard.invest.modal.confirmHint': 'Geben Sie CONFIRM ein, um fortzufahren',
  'user.dashboard.invest.modal.placeholderConfirm': 'CONFIRM',
  'user.dashboard.invest.modal.confirmWithdraw': 'Auszahlung bestätigen',
  'user.dashboard.invest.modal.cancelling': 'Wird abgebrochen…',
  'user.dashboard.invest.toast.cancelled': 'Investition storniert',
  'user.dashboard.invest.toast.cancelFailed': 'Stornierung fehlgeschlagen',

  'notifications.bell.triggerAria': 'Benachrichtigungen',
  'notifications.bell.title': 'Benachrichtigungen',
  'notifications.bell.loading': 'Laden…',
  'notifications.bell.loadErrorSubtitle': 'Benachrichtigungen konnten nicht geladen werden',
  'notifications.bell.unreadOne': '1 ungelesene Aktualisierung',
  'notifications.bell.unreadMany': '{{count}} ungelesene Aktualisierungen',
  'notifications.bell.allCaughtUp': 'Alles gelesen',
  'notifications.bell.markAllRead': 'Alle als gelesen markieren',
  'notifications.bell.empty': 'Noch keine Benachrichtigungen',
  'notifications.bell.emptyError': 'Benachrichtigungen konnten nicht geladen werden',
  'notifications.bell.viewAll': 'Alle anzeigen',
  'notifications.bell.markReadAria': 'Als gelesen markieren',
  'notifications.bell.time.justNow': 'gerade eben',
  'notifications.bell.time.secondsAgo': 'vor {{n}} s',
  'notifications.bell.time.minutesAgo': 'vor {{n}} Min',
  'notifications.bell.time.hoursAgo': 'vor {{n}} Std',
  'notifications.bell.time.daysAgo': 'vor {{n}} T',

  'agent.layout.logout': 'Abmelden',
  'agent.layout.nav.dashboard': 'Dashboard',
  'auth.user.login.title': 'Nutzer-Login',
  'auth.user.login.signIn': 'Anmelden',
  'auth.agent.login.title': 'Agent-Login',
  'auth.agent.login.signIn': 'Anmelden',

  ...panelSettingsTransactionsByLang.de,
  ...panelReferralCurrentRankMinDepositByLang.de,
  ...panelUserExtraByLang.de,
  ...panelDepositWithdrawInboxByLang.de,
  ...panelDepositBonusByLang.de,
  ...panelVoucherStatusByLang.de,
  ...panelInvestmentsByLang.de,
  'user.investments.card.dailyProfit': 'Täglicher Gewinn',
  'user.investments.card.earningDays': 'Werktage',
  'user.investments.card.earningDaysValue': '{{count}} Werktage',
  'user.investments.card.expectedProfit': 'Erwarteter Gewinn',
  'user.investments.card.investLimit': 'Investitionslimit',
  'user.investments.card.investLimitLine': '{{count}}× in {{days}} Tagen',
  'user.investments.card.investLimitReached':
    'Du hast das Investitionslimit für diesen Plan im aktuellen Zeitraum erreicht.',
  'user.investments.card.limitReached': 'Limit erreicht',
  ...panelStopLossSlotsAssignByLang.de,
  ...panelStopLossFlowByLang.de,
  ...panelUserSignupSocialForgotByLang.de,
  ...panelAgentDashboardByLang.de,
  ...panelAgentReferralsByLang.de,
  ...panelAgentCommissionsByLang.de,
  ...panelAgentWithdrawByLang.de,
  ...panelAgentWithdrawUnlockStringsByLang.de,
  'agent.withdraw.unlock.loadingTitle': 'Auszahlungsstatus wird geprüft…',
  'agent.withdraw.unlock.loadingSubtitle':
    'Empfehlungsfortschritt und Freischaltungsanforderungen werden geladen',
  'agent.withdraw.form.loadingTitle': 'Auszahlungsdetails werden geladen…',
  'agent.withdraw.form.loadingHint':
    'Bitte warten — Guthaben und Freischaltungsstatus werden geladen',
  'agent.withdraw.unlock.requirementMet': 'Anforderung erfüllt',
  'agent.withdraw.unlock.minDepositHint':
    'Nur geworbene Nutzer (keine Sub-Agenten). Mindestens ${{amount}} abgeschlossene Einzahlungen pro Nutzer.',
  ...panelAgentTransactionsByLang.de,
  ...panelAgentLogsByLang.de,
  ...panelAgentSettingsByLang.de,
  ...panelAgentNotificationsByLang.de,
  ...panelAgentTeamByLang.de,
  ...panelAgentSignupByLang.de,
  ...panelAgentLayoutByLang.de,
  ...panelAgentAuthByLang.de,
  ...panelUserPlatformTodayByLang.de,
  ...panelStopLossHowLayoutByLang.de,
  ...panelSupportTicketsByLang.de,
});